module.exports = __webpack_public_path__ + "static/media/view_sw_logo.6dbe9d4f.png";